import { FC } from 'react';
import { EventRegistrationForm, EventRegistrationFormStatus } from '../generated/api/dsv-public/model';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { prettyPrintDate } from '../util/helper';

type RegistrationFormStatusProps = {
  registrationForm?: EventRegistrationForm;
};

export const RegistrationFormStatus: FC<RegistrationFormStatusProps> = ({ registrationForm }) => {
  const { t } = useTranslation();

  return (
    <>
      {registrationForm?.status === EventRegistrationFormStatus.WAITING_LIST && (
        <Alert severity="info">{t('forms.inactive-form.status-waiting-list')}</Alert>
      )}
      {registrationForm?.status === EventRegistrationFormStatus.WAIT && (
        <Alert severity="warning">{`${t('forms.inactive-form.status-wait')} ${prettyPrintDate(
          registrationForm?.registrationStart
        )}`}</Alert>
      )}
      {registrationForm?.status === EventRegistrationFormStatus.FULL && (
        <Alert severity="warning">{t('forms.inactive-form.status-full')}</Alert>
      )}
      {registrationForm?.status === EventRegistrationFormStatus.CLOSED && (
        <Alert severity="warning">{t('forms.inactive-form.status-closed')}</Alert>
      )}
    </>
  );
};
